import classNames from 'classnames';
import type React from 'react';

export interface ImageBoxProps {
  url: string;
  width?: number;
  size?: number;
  height?: number;
  overlay?: React.ReactNode;
  backgroundColor?: string;
  icon?: React.ReactNode;
  renderItem?: React.ReactNode;
  transparentBackground?: boolean;
}

const transparentBackgroundImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAADFJREFUOE9jZGBgEGHAD97gk2YcNYBhmIQBgWSAP52AwoAQwJvQRg1gACckQoC2gQgAIF8IscwEtKYAAAAASUVORK5CYII=';

export const ImageBox = ({
  url,
  width,
  size = 120,
  height,
  overlay,
  backgroundColor,
  icon,
  renderItem,
  transparentBackground = true,
}: ImageBoxProps) => {
  const background = transparentBackground
    ? `url(${transparentBackgroundImage})  left center`
    : undefined;
  return (
    <div
      className="rounded-md overflow-hidden border border-ds-natural-150 group"
      style={{
        backgroundColor: backgroundColor,
        background: background,
        backgroundSize: '10px',
        height: height ?? size,
        width: width ?? size,
      }}
    >
      <div
        className={classNames('group w-full h-full overflow-hidden relative')}
      >
        {!!icon && <div className={classNames('absolute inset-0')}>{icon}</div>}
        {!!overlay && (
          <div
            className={classNames(
              'absolute inset-0 invisible group-hover:visible'
            )}
          >
            {overlay}
          </div>
        )}
        <div
          className="w-full bg-contain bg-no-repeat bg-center h-full"
          style={{ backgroundImage: `url(${url})` }}
        >
          {renderItem}
        </div>
      </div>
    </div>
  );
};
